import { classNames } from "core/utils"
import { RadioGroup } from "@headlessui/react"
import { OptionValue, ProductOption } from "@lib/swell/storefront-data-hooks/src/types"

export interface RadioLabelDescriptionInputProps {
  option: ProductOption
  onChange?: any
  selected?: string
}

const RadioLabelDescriptionInput: React.FC<RadioLabelDescriptionInputProps> = ({
  option,
  onChange,
  selected,
}) => {
  const { name, values, description } = option
  return (
    <RadioGroup value={selected} onChange={onChange}>
      <RadioGroup.Label className="block text-sm font-medium text-gray-700">
        {name}
      </RadioGroup.Label>
      <RadioGroup.Description as="span" className="text-sm text-gray-500">
        {description}
      </RadioGroup.Description>

      <div className="mt-4 grid grid-cols-1 gap-4">
        {values?.map((value) => (
          <RadioGroup.Option
            as="div"
            key={value.id}
            value={value.name}
            className={({ active, checked }) =>
              classNames(
                active && checked ? "ring-3 ring-primary-500" : "",
                !active && checked ? "ring-2 ring-primary-500" : "",
                "relative block cursor-pointer rounded-lg border border-gray-300 p-4 focus:outline-hidden"
              )
            }
          >
            {({ active, checked }) => (
              <>
                <RadioGroup.Label as="p" className="text-base font-medium text-gray-900">
                  {value.name}
                </RadioGroup.Label>
                <RadioGroup.Description as="p" className="mt-1 text-sm text-gray-500">
                  {value.description}
                </RadioGroup.Description>
                <div
                  className={classNames(
                    active ? "border" : "border-2",
                    checked ? "border-primary-500" : "border-transparent",
                    "pointer-events-none absolute -inset-px hidden rounded-lg"
                  )}
                  aria-hidden="true"
                />
              </>
            )}
          </RadioGroup.Option>
        ))}
      </div>
    </RadioGroup>
  )
}

export default RadioLabelDescriptionInput
